import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import PolicyLayout, { Section } from "@/components/PolicyLayout";
import { COMPANY } from "@/constants/company";

const Line = ({ icon: Icon, label, children }) => (
    <div className="flex gap-3">
        <Icon className="w-4 h-4 text-bubblegum shrink-0 mt-1" />
        <div>
            <div className="text-xs uppercase tracking-wider text-plum/50">{label}</div>
            <div className="text-sm text-plum/80">{children}</div>
        </div>
    </div>
);

export default function Contact() {
    return (
        <PolicyLayout
            eyebrow="Contact" title="Talk to a person." testId="contact-page"
            intro="A small team makes these books by hand, so a real person reads everything that comes in.">

            <Section heading="Reach us">
                <div className="space-y-4">
                    <Line icon={Mail} label="Email">
                        <a href={`mailto:${COMPANY.email}`} className="underline hover:text-plum">{COMPANY.email}</a>
                    </Line>
                    <Line icon={Phone} label="Phone">
                        <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="underline hover:text-plum">{COMPANY.phone}</a>
                    </Line>
                    <Line icon={Clock} label="Hours">{COMPANY.hours}</Line>
                    <Line icon={MapPin} label="Address">{COMPANY.address}</Line>
                </div>
            </Section>

            <Section heading="Before you write">
                <p>
                    <strong>Money left your account but the order isn't confirmed?</strong> Open{" "}
                    <Link to="/library" className="underline hover:text-plum">your library</Link> and use
                    “Money taken but not confirmed?” on that order. Including the UPI or bank reference
                    is what lets us find it fastest.
                </p>
                <p>
                    <strong>Wondering where your book is?</strong> Digital books land within 48 hours of
                    confirmed payment; hardcovers get a tracking email when they ship.
                </p>
                <p>
                    <strong>Want something changed in the artwork?</strong> Reply to your order email —
                    revisions are handled by the illustrator working on your book.
                </p>
            </Section>

            <Section heading="The rest of the fine print">
                <p>
                    <Link to="/terms" className="underline hover:text-plum">Terms of service</Link> ·{" "}
                    <Link to="/privacy" className="underline hover:text-plum">Privacy policy</Link> ·{" "}
                    <Link to="/refund-policy" className="underline hover:text-plum">Payments and refunds</Link>
                </p>
            </Section>
        </PolicyLayout>
    );
}
